// Source-of-truth catalog. Keys are grouped by screen; `{x}` = parameter, `{n, plural, …}` = plural form.
const zhCN = {
  'app.name': 'AssetList',
  'crash.title': '页面出错了',
  'crash.lead': '这个页面在渲染时遇到了错误。你的数据都在本机浏览器里，没有丢失。下面是错误信息，复制后可以发给我们；也可以回首页或刷新继续使用。',
  'crash.copy': '复制错误信息',
  'crash.home': '回首页',
  'crash.reload': '刷新页面',
  'settings.crashes': '最近的错误（本机记录，最多 10 条）',
  'settings.crashesNone': '没有记录到错误。',
  'settings.crashesCopy': '复制全部',
  'settings.crashesClear': '清除记录',
  'about.title': '关于 AssetList',
  'about.footNote': '© 2026 Code Future Canada Inc.。本页中文与英文版本如有歧义，以英文为准。',
  'footer.about': '关于 AssetList',
  'footer.privacy': '隐私',
  'footer.terms': '使用条款',
  'dev.banner': '这是开发版，可能不稳定。遇到功能错误请刷新页面；你的数据保存在本机浏览器里，不会丢失。需要稳定使用，请前往',

  'common.cancel': '取消',
  'common.save': '保存',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.close': '关闭',
  'common.back': '← 上一步',
  'common.continue': '继续 →',
  'common.skip': '暂时跳过 →',
  'common.none': '—',
  'common.loading': '加载中…',
  'common.generate': '生成',
  'common.regenerate': '重新生成',
  'common.generating': '生成中…',
  'common.today': '今日',
  'common.send': '发送',
  'common.retry': '重试',
  'common.stop': '停止',
  'common.unknownError': '未知错误',

  'header.subtitle': '个人资产账本 · 数据只存于本浏览器',
  'header.updated': '更新于 {time}',
  'header.refreshing': ' · 刷新中',
  'header.currency': '显示货币',
  'header.export': '导出备份',
  'header.settings': '设置',
  'header.list': '资产列表',

  'class.stock': '美股',
  'class.etf': 'ETF',
  'class.cash': '现金',
  'class.crypto': '数字货币',

  'fresh.realtime': '实时',
  'fresh.delayed15': '延迟 15 分',
  'fresh.close': '收盘价',
  'fresh.rate': '日汇率',
  'fresh.manual': '手动价格',
  'fresh.nav': '净值 {date}',
  'fresh.navUndated': '净值',
  'fresh.stale': '{label} · 已过期',
  'fresh.none': '无价格',
  'fresh.fx': '汇率 ECB {date}',
  'fresh.fxNone': '汇率未获取',
  'fresh.base': '基准',
  'source.manual': '手动',
  'source.ecb': 'ECB',

  'list.total': 'Total assets · 总资产',
  'list.dayChange': '{amount} · {pct} 今日',
  'list.missing': '{n, plural, other {# 项无价格}}',
  'list.col.asset': '资产',
  'list.col.qty': '数量',
  'list.col.cost': '成本',
  'list.col.price': '现价',
  'list.col.value': '现值 · {ccy}',
  'list.col.day': '今日',
  'list.col.data': '数据',
  'list.items': '{n, plural, other {# 项}}',
  'list.itemsShare': '{n, plural, other {# 项}} · {pct}',
  'list.addAsset': '添加资产',
  'list.deletePortfolio': '删除资产包',
  'list.renameHint': '点击重命名',
  'list.emptyPortfolio': '这个资产包还是空的。',
  'list.newPortfolio': '新建资产包',
  'list.portfolioName': '资产包名称',
  'list.create': '创建',
  'list.confirmDeletePortfolio': '删除资产包「{name}」{n, plural, =0 {} other {及其 # 项资产}}？此操作不可恢复。',
  'list.footerNote': '持仓、成本与 Key 只保存在这台浏览器里。清除浏览器数据即清除一切——请定期导出备份。',
  'list.experts': '专家论股',
  'list.emptyTitle': '从第一个资产包开始',
  'list.emptyBody': '资产包对应一个账户或一类资产，例如「IB 美股账户」「币安数字货币」「现金」。所有数据只保存在这台浏览器里。',
  'list.emptyNoKey': '还没有配置行情 Key：报价来自内置来源，延迟约 15 分；美股只能按准确代码添加。',
  'list.goSetup': '了解各来源',
  'list.cashSub': '{amount} {ccy}',
  'list.cashRate': ' · 汇率 {rate}',
  'list.cashName': '{ccy} 现金',

  'add.title': '添加资产',
  'add.editTitle': '编辑资产',
  'add.to': '到 {name}',
  'add.type': '类型',
  'add.symbol': '代码',
  'add.what': '持有什么',
  'add.whatPlaceholder': '输入代码或名称：AAPL、SHOP、FCUV、FID5982、BTC…',
  'add.whatHint': '美股与加股按代码或名称搜索；加拿大共同基金输入 FundSERV 代码（如 FID5982）；类型与市场由代码自动识别。',
  'add.whatHintNoUsKey': '未配置行情 Key：美股请输入准确代码（如 AAPL、BRK.B）；加股与加拿大共同基金可按名称或代码搜索。按公司名搜索美股需要 Finnhub 或 Massive Key。',
  'add.searching': '搜索中…',
  'add.quick': '或直接添加：',
  'add.noResults': '没有找到 {code}。',
  'add.manualToggle': '手动填写',
  'add.backToSearch': '返回搜索',
  'add.change': '更换',
  'add.navShort': '净值 {nav} · {date}',
  'add.coinNote': '价格来自 Coinbase 公共行情，无需 Key。更多币种后续迭代。',
  'add.amount': '金额',
  'add.quantity': '数量',
  'add.cost': '成本价 · {ccy}（可选）',
  'add.costPlaceholder': '每单位',
  'add.date': '购买日期（可选）',
  'add.manualPrice': '当前价格 · {ccy}（手动）',
  'add.manualPlaceholder': '没有来源认识这个代码时手动填写',
  'add.note': '备注（可选）',
  'add.notePlaceholder': '例如：分两批建仓；财报前不加仓',
  'add.previewPrice': '按当前价格 {price} 计',
  'add.previewRate': '按当前汇率 {rate} 计',
  'add.previewNone': '尚无价格，添加后自动获取',
  'add.value': '现值',
  'add.footNote': '成本价按购入货币记录，显示时按当日汇率换算。',
  'add.submit': '添加资产',

  'detail.openGoogle': '在 Google Finance 打开',
  'detail.openKoyfin': '在 Koyfin 打开',
  'detail.koyfinTitle': 'Koyfin 的公司概览页（需要 Koyfin 账号，免费版即可）；历史财务、估值与图表都从这里进。',
  'detail.editHolding': '编辑持仓',
  'detail.ask': '问专家',
  'detail.confirmDelete': '删除「{name}」？',
  'detail.held': '持有',
  'detail.shares': '股',
  'detail.avgCost': '成本均价',
  'detail.value': '现值 · {ccy}',
  'detail.share': '占总资产',
  'detail.pnl': '相对成本',
  'detail.purchased': '购入日期',
  'detail.cashNote': '现金按 ECB 参考汇率折算，每个工作日 16:00 CET 更新一次；没有走势图。',
  'detail.note': '备注：{note}',
  'detail.chartNote': 'TradingView 图表 · {symbol} · 图表走 Cboe BZX 实时源',
  'detail.news': '新闻',
  'detail.newsSource': 'Massive · 最近',
  'detail.noNews': '暂无新闻。',
  'detail.history': '历史',
  'detail.historySource': 'Massive · 日线',
  'detail.period1m': '1 月',
  'detail.period3m': '3 月',
  'detail.period6m': '6 月',
  'detail.period1y': '1 年',
  'detail.sinceBuy': '持有以来',
  'detail.lockedTitle': '新闻与历史需要 Massive Starter Key',
  'detail.lockedFinnhub': '你当前使用免费的 Finnhub Key：实时报价与基础财务已可用。',
  'detail.lockedNoKey': '当前没有行情 Key。',
  'detail.lockedBody': '历史走势与个股新闻由 Massive Starter（$29/月，用户自付）提供。',
  'detail.lockedCta': '前往设置配置',
  'detail.fundamentals': '基本面',
  'detail.pe': 'PE（TTM）',
  'detail.range52': '52 周区间',
  'detail.beta': 'Beta',
  'detail.dividend': '股息率',
  'detail.mcap': '市值',
  'detail.ecb': 'ECB {date}',

  'experts.title': '专家论股',
  'experts.new': '新讨论',
  'experts.delete': '删除讨论',
  'experts.confirmDelete': '删除这场讨论？',
  'experts.context': '发给专家的持仓上下文',
  'experts.pick': '选择投资风格 · 已选 {n} / {max}',
  'experts.pickHint': '每种风格代表一套公开的投资方法。被选中的风格会各自独立分析你的持仓，再进入辩论。',
  'experts.pickAria': '投资风格',
  'experts.info': '介绍',
  'experts.infoClose': '收起',
  'experts.fixed': '参与者在讨论开始后固定；要换人请开新讨论。',
  'experts.disclaimer': '各位「专家」是按公开投资流派构建的 AI 风格档案，不代表任何真实人物或机构的观点，与其无关，也不构成投资建议。',
  'experts.references': '方法参考：',
  'experts.referencesNote': '各风格由公开著作中阐述的方法归纳而成，与所列作者及其所属机构无关，亦未获其认可；AI 生成的意见不代表其观点。',
  'experts.presets': '预设提问',
  'experts.startTitle': '让几位专家看看你的持仓',
  'experts.startBody': '左侧选择参与者，点一条预设提问或在下面输入你的问题。每位专家并发、独立地回答，你可以随后让他们互相辩论。',
  'experts.needKey': '需要先配置 LLM Key。',
  'experts.goSettings': '前往设置',
  'experts.askPlaceholder': '向专家提问…',
  'experts.round': '第 {n} 轮 · {type}',
  'experts.answer': '回答',
  'experts.debate': '辩论',
  'experts.parallel': ' · {n, plural, other {# 位专家并发}}',
  'experts.me': '我',
  'experts.withContext': '（附持仓上下文）',
  'experts.startDebate': '发起辩论',
  'experts.debateHint': '本轮已结束。专家将逐条对彼此的意见表态。',
  'experts.needTwo': '至少需要 2 位专家在上一轮成功回复',
  'experts.progress': '{done} / {total} 位专家已完成，已完成的将保留。',
  'experts.followUp': '追问，或选一条预设提问…',
  'experts.opinions': '{n, plural, other {# 条意见}}',
  'experts.generating': '生成中',
  'experts.failed': '失败',
  'experts.hidden': '{n, plural, other {# 条}}置信度低于 {pct}% 的意见未显示',
  'experts.expand': '展开完整分析 ▾',
  'experts.collapse': '收起分析 ▴',
  'experts.all': '全部',
  'experts.expandAll': '全部展开 ▾',
  'experts.collapseAll': '全部收起 ▴',
  'experts.noLLM': '请先在设置中配置 LLM Key。',
  'experts.untitled': '未命名讨论',
  'experts.contextIntro': '——\n我的持仓上下文（自动生成，金额按占比表述）：',

  'preset.concentration.label': '评估当前持仓的集中度与风险',
  'preset.concentration.text': '请评估我当前持仓的集中度与主要风险：哪些敞口过大、哪些相关性被低估、现金比例是否合理。给出具体到仓位百分比的意见。',
  'preset.action.label': '现在应该加仓、减仓还是不动？',
  'preset.action.text': '基于当前持仓与市场环境，我现在应该加仓、减仓还是不动？请针对具体持仓给出方向、幅度和触发条件。',
  'preset.missing.label': '这份组合缺少什么？',
  'preset.missing.text': '这份组合缺少什么？请从资产类别、风险因子、流动性和时间维度指出空缺，并说明是否值得补。',
  'preset.stress.label': '做一次压力测试',
  'preset.stress.text': '请对我的组合做一次压力测试：假设利率再上行 50bp、美股回撤 15%、加密回撤 40%，分别估算组合影响，并指出最脆弱的一环。',

  'ctx.total': '总资产约 {amount} USD（按当前报价与 ECB 汇率折算）',
  'ctx.classes': '大类占比：股票 {stock} · ETF {etf} · 共同基金 {fund} · 现金 {cash} · 数字货币 {crypto}',
  'ctx.day': '今日变动：{pct}（已知涨跌的持仓）',
  'ctx.detail': '持仓明细（按占比降序）：',
  'ctx.cash': '{ccy} 现金',
  'ctx.weight': '占比 {pct}',
  'ctx.price': '现价 {price} {ccy}（报价时间 {at}）',
  'ctx.priceManual': '现价 {price} USD（手动填写）',
  'ctx.rate': '汇率 1 {ccy} = {usd} USD',
  'ctx.today': '今日 {pct}',
  'ctx.open': '开盘 {price}',
  'ctx.range': '最低–最高 {low}–{high}',
  'ctx.range24h': '24 小时最低–最高 {low}–{high}',
  'ctx.prevClose': '昨收 {price}',
  'ctx.prevNav': '前一净值 {price}',
  'ctx.pnl': '相对成本 {pct}',
  'ctx.since': '持有自 {date}',
  'ctx.note': '备注：{note}',
  'ctx.unpriced': '另有 {n, plural, other {# 项}}持仓暂无价格，未计入总额与占比：',
  'ctx.empty': '（当前没有已定价的持仓）',
  'ctx.benchHead': '市场基准（来自 TMX Money，报价时间为 ET。「ETF 代理」= 用跟踪该指数的 ETF 当日涨跌代替指数本身，两者通常相差不超过 0.1 个百分点；ETF 价格不是指数点位，故不列）：',
  'ctx.benchProxy': '{label}（ETF 代理 {proxy}）',
  'ctx.benchLevel': '点位 {level}',
  'ctx.benchAt': '报价时间 {at}',
  'bench.spx': '标普 500',
  'bench.dji': '道琼斯工业平均',
  'bench.nasdaq': '纳斯达克综合',
  'bench.tsx': 'S&P/TSX 综合指数',


  'setup.title': '首次配置',
  'ds.colSource': '来源',
  'ds.colCost': '费用',
  'ds.colGives': '提供什么',
  'ds.colWhen': '什么时候需要',
  'ds.builtin.name': '内置（无需 Key）',
  'ds.builtin.cost': '免费',
  'ds.builtin.gives': '美股、加股、ETF、CDR 与加拿大共同基金的报价（TMX Money，延迟约 15 分）；数字货币（Coinbase）；汇率（欧洲央行）。',
  'ds.builtin.when': '只想看持仓价值、涨跌与日报：什么都不用配。美股按准确代码添加，不能按名称搜索。',
  'ds.finnhub.name': 'Finnhub',
  'ds.finnhub.cost': '免费 Key',
  'ds.finnhub.gives': '美股 / 美国 ETF 实时报价；按名称搜索美股；公司资料与基本面。',
  'ds.finnhub.when': '需要美股实时价格，或想按公司名找代码。',
  'ds.massive.name': 'Massive Starter',
  'ds.massive.cost': '$29 / 月，自付',
  'ds.massive.gives': '5 年历史走势与个股新闻（资产详情页）；美股报价（延迟 15 分，有 Finnhub 时仍优先 Finnhub）。',
  'ds.massive.when': '需要在详情页看历史走势和新闻。',
  'ds.twelvedata.name': 'Twelve Data Grow',
  'ds.twelvedata.cost': '$29 / 月，自付',
  'ds.twelvedata.gives': 'TSX / TSXV / CSE / Cboe Canada 实时报价，含 CDR。',
  'ds.twelvedata.when': '需要加股实时价格；不配置则用内置的延迟报价。',
  'ds.note': 'Key 只保存在这台浏览器里，直接发往对应提供商；几把 Key 可以同时配置，各管各的。',
  'setup.titleAgain': '配置向导',
  'setup.welcomeTitle': '欢迎使用 AssetList',
  'setup.welcomeLead': '一个放在你自己浏览器里的资产查看工具。',
  'setup.introWhatLabel': '它能做什么',
  'setup.introWhat1': '一个页面看全部持仓的价值与涨跌：美股、加股与 CDR、ETF、共同基金、现金、数字货币，按你选的货币折算。',
  'setup.introWhat2': '用你自己的 AI Key 生成前瞻 / 收盘日报、持仓体检与压力测试；也可以只复制提示词，粘贴到你自己的 ChatGPT / Claude / Gemini。',
  'setup.introWhat3': '八种投资风格的 AI 各自独立分析你的持仓，再互相辩论。',
  'setup.introPrivacyLabel': '数据与隐私',
  'setup.introPrivacy1': '没有服务器，没有账号。持仓、成本、Key、快照全部保存在这台浏览器里，不会上传到任何地方。',
  'setup.introPrivacy2': '行情与 AI 请求由浏览器直接发给你自己账户对应的提供商，AssetList 不经手；你可以在浏览器的网络面板里核对每一个请求的去向。',
  'setup.introPrivacy3': '发给 AI 的持仓上下文是代码、占比、涨跌、相对成本的百分比和总资产的近似值，不含账户、券商或任何身份信息；你随时可以在「专家论股」页看到发出的原文。',
  'setup.introPrivacy4': '清除站点数据即清除一切——请在设置里定期导出备份。',
  'setup.introNextLabel': '接下来',
  'setup.introNext1': '三步：LLM Key（可选）、行情 Key（可选）、建第一个资产包。每一步都可以跳过。',
  'setup.introNext2': '之后随时可以在设置里修改，或重新运行这个向导。',
  'setup.aboutLink': '关于 AssetList：为什么做它、隐私如何保护、免责声明与使用条款 →',
  'setup.begin': '开始配置 →',
  'setup.enterNow': '先进去看看，稍后再配置',
  'settings.rerunSetup': '重新运行配置向导',
  'settings.rerunSetupHint': '会重新介绍这个工具与数据存放方式，并逐步核对 Key 与资产包；已有设置不会被清除。',
  'settings.aboutLink': '隐私说明、免责声明与使用条款',
  'setup.tagline': '没有服务器，没有账号——只需要把你自己的 Key 交给你自己的浏览器。',
  'setup.step1': 'LLM Key',
  'setup.step2': '行情数据 Key',
  'setup.step3': '完成',
  'setup.verified': '· 已验证',
  'setup.llmTitle': '连接你的 LLM',
  'setup.llmLead': '专家论股与报告的站内生成由你选定的模型完成，费用走你自己的账户。不配置也能用：报告模板支持把提示词复制到你自己的 ChatGPT / Claude / Gemini。三家任选其一，之后可在设置中更换。',
  'setup.llmNotice': 'Key 只保存在这台浏览器的本地存储里，直接发往提供商的官方接口。AssetList 没有服务器，也看不到它——你可以在浏览器的网络面板里核对每一个请求的去向。',
  'setup.later': '稍后再说',
  'setup.dataTitle': '选择行情数据方案',
  'setup.dataLead': '不配置任何 Key 也能用。行情由你自己的账户直连获取，AssetList 不经手；下表说明四种来源各提供什么、什么时候需要。',
  'setup.dataPick': '现在只需要决定一件事：要不要美股实时报价。要的话申请一把免费的 Finnhub Key；其余都可以之后在设置里加。',
  'setup.free': '免费',
  'setup.finnhub1': '美股 / ETF 实时报价、基础财务、代码搜索',
  'setup.finnhub2': '60 次 / 分钟，单人使用足够',
  'setup.finnhub3': '不含历史走势与个股新闻',
  'setup.finnhubApply': '申请免费 Key（约 1 分钟）→',
  'setup.massivePrice': '$29 / 月 · 自付',
  'setup.massive1': '美股 / ETF 报价（延迟 15 分）、代码搜索',
  'setup.massive2': '5 年历史走势与个股新闻，解锁资产页的历史与新闻区',
  'setup.massive3': '个人用途许可，Key 归你所有',
  'setup.massiveApply': '前往 massive.com 订阅 →',
  'setup.dataNotice': '这把 Key 只会发往 {host}。清除站点数据即清除一切，之后请记得导出备份。',
  'setup.skipHint': '不配置也能用：报价来自内置来源，延迟约 15 分',
  'setup.portfolioTitle': '建立第一个资产包',
  'setup.portfolioLead': '资产包对应一个账户或一类资产，名称随时可改。之后在列表里给它添加资产。',
  'setup.portfolioName': '资产包名称',
  'setup.portfolioPlaceholder': '例如：IB 美股账户',
  'setup.portfolioDefault': 'IB 美股账户',
  'setup.portfolioHave': '已有 {n, plural, other {# 个资产包}}。',
  'setup.enter': '进入资产列表 →',

  'keys.llmKey': '{provider} API Key',
  'keys.finnhubKey': 'Finnhub API Key',
  'keys.massiveKey': 'Massive API Key',
  'keys.massivePlaceholder': '粘贴 Massive API Key',
  'keys.providerNote': '专家论股与盘前盘后分析统一使用该提供商，费用走你的账户。',
  'keys.verify': '保存并验证',
  'keys.verifying': '验证中…',
  'keys.verifiedModels': '已验证 · {n, plural, other {# 个模型可用}}',
  'keys.verifyFailedFallback': '验证失败：{error}。已加载离线模型清单，可先选模型。',
  'keys.verifiedFinnhub': '已验证 · 实时报价可用 · {sample}',
  'keys.verifiedMassive': '已验证 · 延迟 15 分报价可用 · {sample}',
  'keys.verifyFailed': '验证失败：{error}',
  'keys.statusLive': '已验证 · {n, plural, other {# 个模型}} · {date}',
  'keys.statusFallback': '使用离线模型清单，未验证',
  'keys.statusOk': '已验证 · {detail}',
  'keys.statusInvalid': 'Key 无效：{detail}',
  'keys.statusUnverified': '未验证',
  'keys.statusNone': '未配置',
  'keys.clear': '清除 Key',
  'keys.model': '默认模型',
  'keys.modelPlaceholder': '— 先保存并验证 Key —',
  'keys.modelNote': '标题等辅助任务自动使用同家轻量档',

  'settings.title': '设置',
  'settings.navLLM': 'LLM 与模型',
  'settings.navData': '行情数据 Key',
  'settings.navDisplay': '显示',
  'settings.navPrivacy': '数据与隐私',
  'settings.finnhubOk': '已验证 · 实时报价',
  'settings.massiveOk': '已验证 · 历史与新闻',
  'settings.keyInvalid': 'Key 无效',
  'settings.keyNone': '未配置',
  'settings.finnhubMeta': '免费 · 60 次/分 · ',
  'settings.apply': '申请 →',
  'settings.massiveMeta': '$29/月 自付 · 5 年历史 · 个股新闻 · ',
  'settings.subscribe': '订阅 →',
  'settings.language': '语言',
  'settings.languageAuto': '跟随浏览器（{detected}）',
  'settings.currency': '显示货币',
  'settings.fx': '汇率',
  'settings.fxText': 'ECB 参考汇率 · 每个工作日 16:00 CET 更新',
  'settings.fxCurrent': ' · 当前 {date}',
  'settings.costNote': ' · 成本价按购入货币记录',
  'settings.refresh': '刷新',
  'settings.refreshText': '交易时段每 60 秒（仅页面可见时）；数字货币 24 小时；休市显示收盘价并标注',
  'settings.refreshNow': '立即刷新',
  'settings.change': '涨跌',
  'settings.changeText': '显示"今日涨跌"',
  'settings.changeNote': ' · 持仓盈亏含分红、拆股的处理第二期',
  'settings.export': '导出全部数据 · JSON',
  'settings.import': '导入备份',
  'settings.clear': '清空本地数据',
  'settings.stats': '{portfolios, plural, other {# 个资产包}} · {assets, plural, other {# 项}} · 净值快照 {days, plural, other {# 天}} · 约 {size}',
  'settings.promise1': 'AssetList 没有存储用户数据的服务器。持仓、成本、Key 只在这台浏览器里。',
  'settings.promise2': '你的数据只发往你自己配置的账户：行情商与 LLM 提供商。专家论股会把持仓概览（按占比）发给你选定的 LLM。',
  'settings.promise3': '所有请求都从你的浏览器直接发出；你可以在浏览器网络面板里核对每一个请求的去向。',
  'settings.confirmClear': '清空本地全部数据（{portfolios, plural, other {# 个资产包}}、{assets, plural, other {# 项资产}}、{days, plural, other {# 天净值快照}}）？此操作不可恢复，建议先导出备份。',
  'settings.cleared': '已清空本地数据',
  'settings.importFailed': '导入失败：{error}',

  'notice.exported': '备份已导出（不含 Key）',
  'notice.imported': '已导入 {portfolios, plural, other {# 个资产包}}、{assets, plural, other {# 项资产}}',
  'notice.notBackup': '这不是 AssetList 的备份文件',
  'notice.fxFailed': '汇率获取失败：{error}',
  'notice.quotesFailed': '股票报价获取失败：{error}',
  'notice.priceFailed': '无法获取 {symbol} 的价格：{error}',
  'notice.interrupted': '页面刷新导致生成中断',

  'err.connect': '无法连接 {label}',
  'err.invalidKey': '{label} Key 无效或无权限（{status}）{detail}',
  'err.rateLimited': '{label} 限流（429）',
  'err.notFound': '{label} 未找到该代码',
  'err.upstream': '{label} 返回 {status}{detail}',
  'err.noQuote': '{label} 没有 {symbol} 的报价',
  'err.noSnapshot': 'Massive 未返回 {symbol} 快照',

  'llm.aborted': '已手动停止',
  'llm.connect': '无法连接 {host}',
  'llm.invalidKey': 'Key 无效或无权限（{status}）{detail}',
  'llm.quota': '提供商额度用尽或余额不足（{status}）{detail}。可到提供商账单页充值，或在设置中切换其他 AI 提供商。',
  'llm.rateLimited': '提供商限流（429）{detail}',
  'llm.contextTooLong': '上下文超出模型上限（400）{detail}',
  'llm.upstream': '提供商返回 {status}{detail}',
  'llm.streamError': '流式响应报错',
  'llm.streamInterrupted': '流式读取中断：{error}',
  'llm.badJson': '模型输出不是合法的 chatResponse JSON',
  'llm.blocked': '请求被拦截：{reason}',

  'run.busy': '本讨论已有进行中的轮次',
  'run.noLLM': '尚未配置 LLM Key 或默认模型，请先前往设置。',
  'run.unknownProfile': '未知 Profile：{id}',
  'run.repair': '你的上一条输出不是合法的 JSON。请把同样的意见重新输出为符合契约的单个 JSON 对象，不要任何其他内容。',
  'run.titleSystem': '你负责给一段讨论起标题。只输出标题本身：不超过 12 个字，不加引号、书名号、markdown 标记或句末标点。',
  'run.titleUser': '问题：{question}\n\n结论：\n{conclusions}',
  'run.debateReplay': '[DEBATE] 各专家针对上一轮其他专家的意见逐条表态（同意 / 反对 / 补充）。',
  'run.debateInstruction': '[DEBATE] 上一轮各位专家已给出意见（见上文）。你是 {name}。请针对**其他**专家的每条主要意见逐条表态——同意、反对或补充，说明理由，并为每条表态给出置信度。保持你自己的认知框架与硬约束，不要为附和而改变立场。',
  'run.replayConfidence': '（置信度 {pct}%）',
  'run.expertFallback': '专家',
  'list.featLabel': '基于这份资产 · 两个可选功能',
  'list.featOptional': '不用也不影响记账',
  'list.featReportsCount': '{n} 个模板',
  'list.featReportsBody': '前瞻日报、收盘日报、持仓体检、压力测试。在站内生成，或把填好持仓的提示词复制到你自己的 ChatGPT / Claude 里跑。',
  'list.featExpertsCount': '{n} 种投资风格',
  'list.featExpertsBody': '让 AI 以几种不同的投资风格各自评价这份持仓，再互相辩论。需要你自己的 LLM Key。',
  'list.featLast': '最近：{what}',
  'list.featNone': '尚未使用',
  'list.open': '打开 →',
  'reports.title': '报告',
  'reports.heading': '选一个模板，两种用法',
  'reports.lead': '每个模板都是一份写好的提示词。可以在站内用你的 API Key 直接生成，也可以复制到你自己的 ChatGPT、Claude 或 Gemini 里运行——走你已有的订阅，不产生 API 费用。持仓会按占比自动填入。',
  'reports.snapshot': '持仓快照 {time} ET · {n, plural, other {# 项}} · {total}',
  'reports.llmBadge': '站内生成：{model} · 你的 Key',
  'reports.noKeyBadge': '未配置 LLM Key · 仍可复制提示词',
  'reports.needsWeb': '需联网搜索',
  'reports.offline': '基于持仓',
  'reports.searches': '约 {n} 次搜索',
  'reports.estCost': '站内约 {usd} / 次',
  'reports.copy': '复制提示词',
  'reports.run': '在站内生成',
  'reports.running': '生成中…',
  'reports.waitClose': '等待收盘',
  'reports.lastToday': '最近：今日 {time}',
  'reports.last': '最近：{date}',
  'reports.never': '尚未生成',
  'reports.view': '查看',
  'reports.waysTitle': '两种用法',
  'reports.way1Title': '复制提示词，用你自己的账号',
  'reports.way1Body': '打开 ChatGPT、Claude 或 Gemini 网页版，粘贴，开启联网搜索再发送。走你已有的订阅，不产生 API 费用。结果不会回到这里。',
  'reports.way2Title': '在站内生成，用你的 API Key',
  'reports.way2Body': '自动填入持仓与当前时间，结果保存在本浏览器，可导出、可拿去问专家。按用量付费，卡片上有估算。',
  'reports.privacy': '两种用法发出的内容一样：总资产、各项占比与现价、今日涨跌、相对成本。不含数量、成本金额与账户名。',
  'reports.recent': '最近生成 · 存于本浏览器',
  'reports.noRecent': '还没有生成过报告。',
  'reports.scenarioPlaceholder': '情景：例如「明日 AAPL 财报不及预期，纳指 −3%」',
  'reports.needAssets': '先添加资产',
  'tpl.premarket.name': '前瞻日报',
  'tpl.premarket.when': '盘前 · 开盘前看',
  'tpl.premarket.desc': '每项持仓过去 24 小时的新闻与公告；美国通胀、就业、美联储；加密与外币要点；今日关注清单。每条附来源链接。',
  'tpl.postmarket.name': '收盘日报',
  'tpl.postmarket.when': '盘后 · 16:00 ET 后',
  'tpl.postmarket.desc': '三大指数收盘与驱动因素；每项持仓跑赢还是跑输大盘的对照表；逐项的开盘、收盘与涨跌归因；下一交易日关注。休市日改为当天要闻摘要。',
  'tpl.checkup.name': '持仓体检',
  'tpl.checkup.when': '随时',
  'tpl.checkup.desc': '从集中度、相关性、现金与流动性四个角度审视当前持仓，指出缺什么，并给出每项的仓位区间建议。',
  'tpl.stress.name': '压力测试',
  'tpl.stress.when': '随时',
  'tpl.stress.desc': '设定一个情景（如纳指单日 -5%），估算它对每项持仓与总资产的影响，并给出应对的先后顺序。',
  'tpl.stress.defaultScenario': '美股大盘单日下跌 5%，纳指下跌 7%',
  'copy.title': '复制提示词',
  'copy.language': '输出语言',
  'copy.hint.web': '这份报告要联网。粘贴到 ChatGPT、Claude、Gemini 或其他聊天工具前，确认已开启网页搜索（ChatGPT 的「搜索」、Claude 的网页搜索；Gemini 默认可以）。粘贴后直接发送即可；如果结果没有来源链接，追问一句"请给每条信息附上来源链接"。',
  'copy.hint.offline': '粘贴后直接发送即可。',
  'copy.preview': '将要复制的内容 · 已填入今日持仓',
  'copy.size': '约 {n} 字 · {time} ET 快照',
  'copy.privacy': '包含总资产、各项占比与现价、今日涨跌、相对成本；不含数量、成本金额与账户名。',
  'copy.instead': '改为在站内生成',
  'copy.download': '下载 .md',
  'copy.all': '复制全部',
  'copy.copied': '已复制',
  'report.regenerate': '重新生成',
  'report.export': '导出 · Markdown',
  'report.askExperts': '拿去问专家',
  'report.meta': '{time} ET 站内生成 · {model}',
  'report.metaSearches': '{n, plural, other {# 次搜索}}',
  'report.today': '今日已生成 · 打开不重复',
  'report.inputs': '输入 · 均来自本浏览器',
  'report.snapshot': '持仓快照',
  'report.total': '总资产',
  'report.positions': '持仓项数',
  'report.fxDate': '汇率日期',
  'report.scenario': '情景',
  'report.queries': '搜索计划 · {n}',
  'report.cost': '本次费用',
  'report.costSearches': '搜索 {n} 次',
  'report.costTokens': '输入 {i} · 输出 {o} tokens',
  'report.costTotal': '合计',
  'report.costNoteFeed': '按提供商返回的用量计算，非估算；单价来自 LiteLLM 公开价格表（{date} 更新）。',
  'report.costNoteApprox': '按提供商返回的用量计算；{model} 在价格表里没有官方条目，单价按同名模型的转售报价近似（LiteLLM 价格表，{date}）。',
  'report.costNoteBuiltin': '按提供商返回的用量计算，非估算；在线价格表暂不可用，单价来自内置价格表（{date}）。',
  'report.costUnknown': '该模型不在价格表中，仅显示用量。价格表每天自动更新，新模型通常几天内会收录；收录后这里会自动补上费用。',
  'report.disclaimer': '由你配置的 LLM 生成，仅为信息整理，不构成投资建议。来源为生成时的实时搜索结果。',
  'report.sourcesHeading': '参考来源',
  'report.failed': '{name}生成失败：{error}',
  'report.noAssets': '还没有持仓，先添加资产（观察项不参与报告）。',
  'setup.optional': '· 可选',
  'market.US': '美国',
  'market.CA': '加拿大',
  'class.stockCA': '加股',
  'class.etfCA': '加拿大 ETF',
  'class.cdr': 'CDR',
  'ctx.cdr': 'CDR，加元计价、含汇率对冲的美股存托凭证',
  'add.market': '市场',
  'add.cdrHint': 'CDR：加元计价、内含汇率对冲的美股存托凭证，在 Cboe Canada 与 TSX 交易。报价取 CDR 本身，不是美股原价。',
  'keys.twelvedataKey': 'Twelve Data API Key',
  'keys.twelvedataPlaceholder': '粘贴 Twelve Data API Key',
  'keys.verifiedTwelvedata': '已验证 · 加拿大报价可用 · {sample}',
  'settings.twelvedataOk': '已验证 · 加拿大报价',
  'settings.twelvedataMeta': 'Grow $29/月 自付 · TSX / TSXV / CSE / Cboe Canada 实时报价，含 CDR；不配置时加元报价走 TMX Money（免费，延迟 15 分） · ',
  'class.fund': '共同基金',
  'class.fundCA': '加拿大共同基金',
  'ctx.fund': '共同基金（场外申购，FundSERV 代码，不在交易所交易），价格为每日公布的净值',
  'add.fundCode': '基金代码（FundSERV）',
  'add.fundName': '基金名称',
  'add.fundNamePlaceholder': '例如 Fidelity Global Innovators Class F',
  'add.units': '份额',
  'add.nav': '净值 · {ccy}',
  'add.navNote': '加拿大共同基金按 FundSERV 代码从 TMX Money 自动取净值（每个交易日晚间更新）；这里填的净值只在查不到时使用。',
  'add.tmxFund': 'TMX Money：{name} · 净值 {nav} {ccy}（{date}）',
  'add.tmxFundMiss': 'TMX Money 没有 {code} 这个代码，请核对，或手动填净值。',
  'add.navLookup': '查 {code} 的净值 →',
  'add.classHint.etf': 'ETF 在交易所买卖、有股票代码、盘中有报价。向基金公司或银行申购、只有每日净值的基金请选「共同基金」。',
  'add.classHint.fund': '共同基金（互惠基金）向基金公司或银行申购，没有交易所代码，按 FundSERV 代码识别，每天公布一次净值。在交易所交易的 ETF 请选「ETF」。',
  'detail.openGoogleFund': '在 Google Finance 查净值',
  'detail.updateNav': '手动填净值',
  'detail.refreshNav': '刷新净值',
  'detail.refreshingNav': '刷新中…',
  'detail.navRefreshed': '{symbol} 净值 {nav} {ccy}（{date}）',
  'detail.navNotFound': 'TMX Money 没有 {symbol} 的净值；可用下方「联网查净值」或手动填写。',
  'detail.units': '份',
  'detail.fundNote': '共同基金，净值手动维护，最近更新 {date}。没有走势图。',
  'detail.fundTmx': '共同基金，净值来自 TMX Money，{date} 公布；每个交易日晚间自动更新。没有走势图。',
  'detail.fundNoDate': '共同基金，净值手动维护。没有走势图。',
  'fresh.manualDated': '手动 · {date}',
  'nav.lookup': '联网查净值',
  'nav.looking': '查询中…',
  'nav.found': '查到 {nav} {ccy} · {date} · 来源 {source}{cost}',
  'nav.apply': '采用',
  'nav.applied': '已更新净值 {nav} {ccy}（{date}）',
  'nav.check': '币种不符或日期超过 10 天，请核对后再采用。',
  'nav.needLLM': '需要先配置 LLM Key',
  'nav.unparsable': '模型没有返回可解析的净值',
  'nav.notFound': '没有查到可靠的净值：{reason}',
  'nav.rejected': '查到 {nav} {ccy}（{date}），币种不符或日期过旧，未采用',
  // 观察项（数量为 0 的资产）
  'add.watchHint': '数量填 0 即加入观察：只跟踪行情，不计入总资产，也不进入日报与专家讨论。想买了再把数量改成实际持仓。',
  'add.watchToHolding': '这是观察项。填上实际持有数量，它就成为持仓：计入总资产，进入日报与专家讨论。',
  'add.previewWatch': '观察项，不计现值',
  'add.submitWatch': '加入观察',
  'list.watch': '观察',
  'detail.watching': '观察中',
  'detail.watchNote': '观察项：只跟踪行情，不计入总资产，也不进入日报与专家讨论。要转为持仓，点「编辑持仓」填上数量。',
} as const;

export default zhCN;
